import { render, staticRenderFns } from "./profit_details.vue?vue&type=template&id=c950b4f0&scoped=true&"
import script from "./profit_details.vue?vue&type=script&lang=js&"
export * from "./profit_details.vue?vue&type=script&lang=js&"
import style0 from "./profit_details.vue?vue&type=style&index=0&id=c950b4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c950b4f0",
  null
  
)

export default component.exports